"use strict";
/**
* Copyright: Microsoft 2016
*/
Object.defineProperty(exports, "__esModule", { value: true });
var TypeCheck = /** @class */ (function () {
    function TypeCheck() {
    }
    TypeCheck.isJsxElement = function (value) {
        return value.props;
    };
    TypeCheck.isString = function (value) {
        return typeof value === 'string';
    };
    TypeCheck.isLocalizableElement = function (value) {
        return value.translationKey && !value.type;
    };
    TypeCheck.isDomElement = function (value) {
        return !!value.type;
    };
    return TypeCheck;
}());
exports.TypeCheck = TypeCheck;
